import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid-pro';
import { useScheduleDesviationQuery } from './useScheduleDesviationQuery';
import { useScheduleDesviationTableState } from './useScheduleDesviationTableState';

export const useScheduleDesviationTable = () => {
    const { t } = useTranslation();
    const { rows, setRows, loading, setLoading, loadData } = useScheduleDesviationQuery();
    const { contextMenu, setContextMenu, selectedRow, setSelectedRow, selected, setSelected, cleanSelected } = useScheduleDesviationTableState();

    const columns: GridColDef[] = useMemo(
        () => [
            {
                field: 'name',
                headerName: t('settings.schedule_desviation.table.columns.name'),
                flex: 1,
            },
            {
                field: 'description',
                headerName: t('settings.schedule_desviation.table.columns.description'),
                flex: 1,
                filterable: false,
            },
            {
                field: 'before_shift',
                headerName: t('settings.schedule_desviation.table.columns.before_shift'),
                flex: 1,
                filterable: false,
                renderCell: (params) => {
                    if (params.value) {
                        return t('settings.schedule_desviation.table.columns.enable');
                    } else {
                        return t('settings.schedule_desviation.table.columns.disabled');
                    }
                },
            },
            {
                field: 'after_shift',
                headerName: t('settings.schedule_desviation.table.columns.after_shift'),
                flex: 1,
                filterable: false,
                renderCell: (params) => {
                    if (params.value) {
                        return t('settings.schedule_desviation.table.columns.enable');
                    } else {
                        return t('settings.schedule_desviation.table.columns.disabled');
                    }
                },
            },
            {
                field: 'requires_approval',
                headerName: t('settings.schedule_desviation.table.columns.requires_approval'),
                flex: 1,
                align: 'center',
                filterable: false,
                renderCell: (params) => {
                    if (params.value) {
                        return t('settings.schedule_desviation.table.columns.enable');
                    } else {
                        return t('settings.schedule_desviation.table.columns.disabled');
                    }
                },
            },
            {
                field: 'unplanned',
                headerName: t('settings.schedule_desviation.table.columns.unplanned'),
                flex: 1,
                renderCell: (params) => {
                    if (params.value) {
                        return t('settings.schedule_desviation.table.columns.enable');
                    } else {
                        return t('settings.schedule_desviation.table.columns.disabled');
                    }
                },
                filterable: false,
            },
        ],
        [t],
    );

    const reloading = useCallback(() => {
        const permissions = JSON.parse(localStorage.getItem('permissions') || '[]') as string[];
        const canReadScheduleDesviation = permissions.includes('timekeeper.ScheduleDesviationRule');

        if (canReadScheduleDesviation) {
            loadData().finally(() => {
                setContextMenu(null);
                cleanSelected();
            });
        } else {
            setRows([]);
            setLoading(false);
        }
    }, [cleanSelected, loadData, setContextMenu, setLoading, setRows]);

    return {
        rows,
        loading,
        loadData,
        reloading,
        selectedRow,
        setSelectedRow,
        contextMenu,
        setContextMenu,
        selected,
        setSelected,
        columns,
        cleanSelected,
    };
};
